import type { StatusRewardBenefit, StatusRewardView } from '../types/statusRewards';
import type { GroupedGamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';
import { GamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';
import { STATUS_REWARD_BENEFITS } from '../constants/statusRewardBenefits';

const VIEW_ORDER: Partial<Record<StatusRewardView, readonly GroupedGamificationRewardType[]>> = {
  rewards: [
    GamificationRewardType.LossInsurance,
    GamificationRewardType.Referral,
    GamificationRewardType.WinnersPool,
    GamificationRewardType.LevelUp,
    GamificationRewardType.HigherDailyRedemption,
    GamificationRewardType.StatusUp,
  ],
};

export const getStatusRewardBenefits = (view: StatusRewardView): readonly StatusRewardBenefit[] => {
  const order = VIEW_ORDER[view];
  if (!order) {
    return STATUS_REWARD_BENEFITS;
  }

  const rank = (type: GroupedGamificationRewardType) => {
    const index = order.indexOf(type);
    return index === -1 ? order.length : index;
  };

  return [...STATUS_REWARD_BENEFITS].sort((a, b) => rank(a.type) - rank(b.type));
};
